import styled from "styled-components";
import { Device } from "@pepdirect/v3/styles/screenSizes";

export const StyledGiftForm = styled.div`
  font-size: 13px;

  @media ${Device.laptop} {
    max-width: 420px;
  }
`;

export const StyledCTA = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const StyledLabel = styled.label`
  height: 20px;
`;

export const StyledCTAIcon = styled.div`
  margin: 0 4px 0 8px;
  display: flex;
  align-items: center;
`;

export const StyledForm = styled.div`
  margin-top: 14px;
  height: auto;
`;

export const StyledRequiredFields = styled.div`
  margin: 16px 0;
`;
